import { render, staticRenderFns } from "./selfpickDetails.vue?vue&type=template&id=05b1e279&scoped=true&"
import script from "./selfpickDetails.vue?vue&type=script&lang=js&"
export * from "./selfpickDetails.vue?vue&type=script&lang=js&"
import style0 from "./selfpickDetails.vue?vue&type=style&index=0&id=05b1e279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b1e279",
  null
  
)

export default component.exports